module.exports = __webpack_public_path__ + "img/medical-tests-x.fb1f1c86.svg";